import clsx from "clsx";
import React from "react";
import { DialogProps, Button, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { BaseDialog } from "./BaseDialog";
import { COACH_PLAN_ROUTE } from "../../routes/routes";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
  },

  subtitle: {
    fontSize: 18,
    fontWeight: 400,
    color: theme.palette.text.primary,
    textAlign: "left",
    marginBottom: theme.spacing(3),
  },

  button: {
    fontSize: 16,
    fontWeight: "bold",
    lineHeight: "20px",
    color: theme.palette.common.white,
    padding: theme.spacing(1.5),
  },
}));

export interface CoachSeatsLimitDialogProps extends DialogProps {}

export function CoachSeatsLimitDialog(props: CoachSeatsLimitDialogProps) {
  const { className, onClose, ...other } = props;
  const s = useStyles();
  const navigate = useNavigate();

  const handleButtonClick = React.useCallback(
    (event) => {
      onClose?.(event, "backdropClick");
      navigate(COACH_PLAN_ROUTE, { replace: true });
    },
    [onClose, navigate],
  );

  return (
    <BaseDialog
      className={clsx(s.root, className)}
      title="No Available Coach Seats"
      showClose={true}
      onClose={onClose}
      {...other}
    >
      <Typography variant="body1" className={s.subtitle}>
        You've used all your available coach seats. Please upgrade your plan to
        add more coaches or unarchive existing ones.
      </Typography>
      <Button
        className={s.button}
        fullWidth
        variant="contained"
        children="Go to Plan Page"
        onClick={handleButtonClick}
      />
    </BaseDialog>
  );
}

